module.exports = __webpack_public_path__ + "static/media/xmas-set-2022-2.8b66e188.gif";